export default __webpack_public_path__ + "static/media/pika.a22c2f6b.gif";